export const getCustomErrorMessage = (originalMessage) => {
    // Define Error Message
    let errorMessageMapping = [
        {'original': 'aws.cognito.UserNotFound', 'custom': 'Login Failed, User not found'},
        {'original': 'aws.cognito.UserNotAuthorized', 'custom': 'Authentication Failed, Invalid Password'},
        {'original': 'aws.cognito.UserNotConfirmed', 'custom': 'Please check your inbox for your Validation Email - TONE Networks'},
        {'original': 'aws.cognito.PasswordReset', 'custom': 'Login Failed, Password Reset is required'},
        {'original': 'User.Requested.Not.Found', 'custom': 'User not found'},
        {'original': 'User.Exists', 'custom': 'User Already Exists'}
    ]

    // Filter if message exists
    let exists = errorMessageMapping.filter(mapping => {
        return mapping.original.toLowerCase() === originalMessage.toLowerCase()
    })
    if (exists && exists.length > 0) {
        return exists[0].custom
    } else {
        return originalMessage
    }
}



// WEBPACK FOOTER //
// ./src/store/errorMessageMapping.js